import { IconProps } from '@models/icons';

function Control({ size = 16, color, ...rest }:IconProps) {
  return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
             {...rest}>
            <path d="M6 11.5L6 5" stroke={color} strokeWidth="1.8" strokeLinecap="square"/>
            <path d="M18 11.5L18 5" stroke={color} strokeWidth="1.8" strokeLinecap="square"/>
            <path d="M12 12.5L12 19" stroke={color} strokeWidth="1.8" strokeLinecap="square"/>
            <path d="M6 19L6 17" stroke={color} strokeWidth="1.8" strokeLinecap="square"/>
            <path d="M18 19L18 17" stroke={color} strokeWidth="1.8" strokeLinecap="square"/>
            <path d="M12 5L12 7" stroke={color} strokeWidth="1.8" strokeLinecap="square"/>
            <mask id="path-7-inside-1_4484_3653" fill="white">
                <rect x="4" y="12" width="4" height="5" rx="1"/>
            </mask>
            <rect x="4" y="12" width="4" height="5" rx="1" stroke={color} strokeWidth="2.6" mask="url(#path-7-inside-1_4484_3653)"/>
            <mask id="path-8-inside-2_4484_3653" fill="white">
                <rect x="16" y="12" width="4" height="5" rx="1"/>
            </mask>
            <rect x="16" y="12" width="4" height="5" rx="1" stroke={color} strokeWidth="2.6" mask="url(#path-8-inside-2_4484_3653)"/>
            <mask id="path-9-inside-3_4484_3653" fill="white">
                <rect x="10" y="7" width="4" height="5" rx="1"/>
            </mask>
            <rect x="10" y="7" width="4" height="5" rx="1" stroke={color} strokeWidth="2.6" mask="url(#path-9-inside-3_4484_3653)"/>
        </svg>
  );
}

export default Control;
